import { EmployeeContracts } from "@/pages/human-resources/time-management/business/contract/EmployeeContracts.ts";
import type { ContractOut } from "@/pages/human-resources/time-management/endpoints/contracts/inout/ContractOut.ts";
import { mapToContract } from "@/pages/human-resources/time-management/endpoints/contracts/inout/ContractOut.ts";
import { Employee } from "@/pages/human-resources/time-management/business/Employee.ts";
import { parseIsoDateTime } from "@/shared/utils/Dates.ts";
import {
  mapToWeekDayAvailability,
  type WeekDayAvailabilityOut,
} from "@/pages/human-resources/time-management/endpoints/contracts/inout/WeekDayAvailabilityOut.ts";

export interface EmployeeContractsOut {
  employeeId: number;
  code: string | undefined;
  lastName: string;
  firstName: string;
  email: string | undefined;
  dateOfBirth: string;
  weeklyAvailability: WeekDayAvailabilityOut[];
  contracts: ContractOut[];
}

export function mapToEmployee(
  siteId: string,
  eo: EmployeeContractsOut,
): Employee {
  return new Employee(
    eo.employeeId.toString(),
    eo.code,
    eo.lastName,
    eo.firstName,
    parseIsoDateTime(eo.dateOfBirth),
    eo.email,
    eo.weeklyAvailability.map(mapToWeekDayAvailability),
    new EmployeeContracts(siteId, eo.contracts.map(mapToContract)),
  );
}
